import { EstadoPago } from '@/shared/model/enumerations/estado-pago';

export default function resolveEstadoPagoVariant(estado: EstadoPago) {
  switch (estado) {
    case EstadoPago.CALCULADO:
      return 'primary ';
    case EstadoPago.POR_PAGAR:
      return 'info';
    case EstadoPago.EXCLUIDO:
      return 'dark ';
    case EstadoPago.CANCELADO:
      return 'danger';
    case EstadoPago.RECHAZADO:
      return 'warning';
    case EstadoPago.PAGADO:
      return 'success';
    default:
      return 'primary';
  }
}
